/* LUPA — colourway switching, filter drawer, sticky ATC. Vanilla JS. */
(function () {
  'use strict';

  /* ----------------------------------------------------------
     Card colourway swatches: hover previews, click selects.
     Swaps card image + links to the chosen colourway product.
     ---------------------------------------------------------- */
  function bindCard(card) {
    var img = card.querySelector('[data-card-img]');
    var imgHover = card.querySelector('[data-card-img-hover]');
    var links = card.querySelectorAll('[data-card-link]');
    var colourEl = card.querySelector('[data-card-colour]');

    function apply(swatch) {
      var url = swatch.getAttribute('data-url');
      var image = swatch.getAttribute('data-image');
      var image2 = swatch.getAttribute('data-image-hover');
      var colour = swatch.getAttribute('data-colour');
      if (img && image) {
        img.src = image;
        img.removeAttribute('srcset');
      }
      if (imgHover) {
        if (image2) {
          imgHover.src = image2;
          imgHover.style.display = '';
        } else {
          imgHover.style.display = 'none';
        }
      }
      links.forEach(function (a) { a.href = url; });
      if (colourEl && colour) colourEl.textContent = colour;
      card.querySelectorAll('[data-lupa-swatch]').forEach(function (s) {
        s.classList.toggle('is-active', s === swatch);
        s.setAttribute('aria-current', s === swatch ? 'true' : 'false');
      });
    }

    card.querySelectorAll('.lupa-swatches--card [data-lupa-swatch]').forEach(function (swatch) {
      swatch.addEventListener('click', function (e) {
        e.preventDefault();
        apply(swatch);
      });
      swatch.addEventListener('mouseenter', function () { apply(swatch); });
    });
  }

  /* ----------------------------------------------------------
     PDP colourway switch: fetch the target product's main
     section via the Section Rendering API, swap in place,
     pushState. Falls back to a normal navigation.
     ---------------------------------------------------------- */
  function bindPdp() {
    document.addEventListener('click', function (e) {
      var swatch = e.target.closest('.lupa-swatches--pdp [data-lupa-swatch]');
      if (!swatch) return;
      var wrapper = swatch.closest('.shopify-section');
      if (!wrapper || !wrapper.id) return; // fall back to link
      e.preventDefault();

      var url = swatch.getAttribute('data-url');
      var sectionId = wrapper.id.replace(/^shopify-section-/, '');

      wrapper.style.opacity = '0.4';
      fetch(url + '?section_id=' + encodeURIComponent(sectionId))
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('.shopify-section') || doc.body;
          wrapper.innerHTML = fresh.innerHTML;
          wrapper.style.opacity = '';
          window.history.pushState({ lupaColourway: true }, '', url);
          var colour = swatch.getAttribute('data-colour');
          if (colour && document.title.indexOf(' - ') !== -1) {
            document.title = document.title.replace(/ - [^–|]+/, ' - ' + colour);
          }
          var scroller = document.querySelector('.page-wrapper') || window;
          scroller.scrollTo({ top: 0, behavior: 'auto' });
          initStickyAtc();
          initEta();
        })
        .catch(function () {
          window.location.href = url;
        });
    });

    window.addEventListener('popstate', function (e) {
      if (e.state && e.state.lupaColourway) window.location.reload();
    });
  }

  /* ----------------------------------------------------------
     Filter & sort drawer
     ---------------------------------------------------------- */
  function bindDrawer() {
    var drawer = document.querySelector('[data-lupa-drawer]');
    var scrim = document.querySelector('[data-drawer-scrim]');
    var openBtn = document.querySelector('[data-drawer-open]');
    if (!drawer || !openBtn) return;
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      drawer.hidden = false;
      if (scrim) scrim.hidden = false;
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        if (scrim) scrim.classList.add('is-open');
      });
      document.documentElement.style.overflow = 'hidden';
      var close = drawer.querySelector('[data-drawer-close]');
      if (close) close.focus();
    }
    function shut() {
      drawer.classList.remove('is-open');
      if (scrim) scrim.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(function () {
        drawer.hidden = true;
        if (scrim) scrim.hidden = true;
      }, 320);
      if (lastFocus) lastFocus.focus();
    }

    openBtn.addEventListener('click', open);
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-close]')) shut();
    });
    if (scrim) scrim.addEventListener('click', shut);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) shut();
    });
  }

  /* ----------------------------------------------------------
     Mobile sticky add-to-cart bar on product pages
     ---------------------------------------------------------- */
  var stickyBound = false;
  function initStickyAtc() {
    var buyButton = document.querySelector('product-form-component button[type="submit"], .product-information button[name="add"], button[name="add"]');
    var details = document.querySelector('.product-information, [data-testid="product-information"], product-information');
    if (!buyButton) {
      var bar = document.querySelector('.lupa-sticky-atc');
      if (bar) bar.remove();
      return;
    }

    var existing = document.querySelector('.lupa-sticky-atc');
    if (!existing) {
      existing = document.createElement('div');
      existing.className = 'lupa-sticky-atc';
      existing.innerHTML =
        '<div class="lupa-sticky-atc__meta">' +
        '<span class="lupa-sticky-atc__title"></span>' +
        '<span class="lupa-sticky-atc__price"></span>' +
        '</div>' +
        '<button type="button" class="lupa-sticky-atc__btn">Add to cart</button>';
      document.body.appendChild(existing);
      existing.querySelector('.lupa-sticky-atc__btn').addEventListener('click', function () {
        var live = document.querySelector('product-form-component button[type="submit"], button[name="add"]');
        if (live) live.click();
      });
    }

    var titleEl = document.querySelector('.product-information h1, h1');
    var priceEl = document.querySelector('.product-information [class*="price"], product-price');
    existing.querySelector('.lupa-sticky-atc__title').textContent = titleEl ? titleEl.textContent.trim() : '';
    existing.querySelector('.lupa-sticky-atc__price').textContent = priceEl ? priceEl.textContent.trim().split('\n')[0] : '';

    if (!stickyBound) {
      stickyBound = true;
      window.addEventListener('scroll', function () {
        var bar = document.querySelector('.lupa-sticky-atc');
        var btn = document.querySelector('product-form-component button[type="submit"], button[name="add"]');
        if (!bar || !btn) return;
        var rect = btn.getBoundingClientRect();
        bar.classList.toggle('is-visible', rect.bottom < 0);
      }, { passive: true });
    }
  }

  /* ----------------------------------------------------------
     PDP delivery estimate: countdown to dispatch cutoff + ETA
     ---------------------------------------------------------- */
  function initEta() {
    var el = document.querySelector('[data-lupa-eta]');
    if (!el) return;
    if (window.__lupaEtaTimer) clearInterval(window.__lupaEtaTimer);

    var cutH = parseInt(el.getAttribute('data-cutoff-hour'), 10) || 14;
    var cutM = parseInt(el.getAttribute('data-cutoff-minute'), 10) || 0;
    var days = parseInt(el.getAttribute('data-days'), 10) || 3;
    var textEl = el.querySelector('[data-eta-text]');

    function londonNow() {
      return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/London' }));
    }
    function isWeekend(d) {
      return d.getDay() === 0 || d.getDay() === 6;
    }

    function render() {
      var now = londonNow();

      // next dispatch cutoff: today at HH:MM, rolled forward past weekends
      var ship = new Date(now);
      ship.setHours(cutH, cutM, 0, 0);
      while (ship <= now || isWeekend(ship)) {
        ship.setDate(ship.getDate() + 1);
        ship.setHours(cutH, cutM, 0, 0);
      }

      // add working days for delivery
      var deliver = new Date(ship);
      var added = 0;
      while (added < days) {
        deliver.setDate(deliver.getDate() + 1);
        if (!isWeekend(deliver)) added++;
      }
      var dateStr = deliver.toLocaleDateString('en-GB', {
        weekday: 'long',
        day: 'numeric',
        month: 'long'
      });

      var remaining = ship - now;
      var hrs = Math.floor(remaining / 3600000);
      var mins = Math.ceil((remaining % 3600000) / 60000);
      if (mins === 60) { hrs += 1; mins = 0; }

      if (hrs >= 24) {
        textEl.innerHTML = 'Delivery by <strong>' + dateStr + '</strong>';
      } else {
        var count = hrs > 0 ? hrs + 'h ' + mins + 'm' : mins + (mins === 1 ? ' minute' : ' minutes');
        textEl.innerHTML = 'Order within <strong>' + count + '</strong> for same-day dispatch — delivery by <strong>' + dateStr + '</strong>';
      }
      el.hidden = false;
    }

    render();
    window.__lupaEtaTimer = setInterval(render, 30000);
  }

  function bindFooter() {
    document.querySelectorAll('[data-lupa-footer-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var col = btn.closest('[data-lupa-footer-col]');
        if (!col) return;
        var open = col.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-lupa-card]').forEach(bindCard);
    bindPdp();
    bindDrawer();
    initStickyAtc();
    bindFooter();
    initEta();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
